'use strict'
import { Dialog } from 'construct-ui';
import moment from 'moment';
import checkboxInputComponent from "../../../../components/common/checkbox-input.component";
import codeMasterDropdownInputComponent from "../../../../components/common/codemaster-dropdown-input.component";
import fileInputComponent from "../../../../components/common/file-input-component";
import selectListComponent from "../../../../components/common/select-list.component";
import textInputComponent from "../../../../components/common/text-input.component";
import DatePickerComponent from "../../../../components/date-picker/date-picker.component";
import SelectUserComponent from "../../../../components/user/select-user.component";
import { formats as FORMATS, codeMasterType } from "../../../../config/constants";
import { apiStatusCodes, transStatus } from "../../../../config/global-variables";
import fileModel from "../../../../models/common/file.model";
import loginModel from "../../../../models/login.model";
import userModel from "../../../../models/user/user.model";
import passwordChecker from "../../../../utils/password-checker";
import ViewBase from "../../../view-base.view";

export default function UserCreateInfoFormView() {
  ViewBase.call(this);
  let _isPreviewOpen = false;
  let _base64Image = "";
  let _attrs;
  let _userInfoForm = {
    userId: '',
    userName: '',
    countryCode: '',
    userType: '',
    knoxID: '',
    email: '',
    password: '',
    confirmPassword: '',
    divisionGroup: [],
    languageCode: '',
    mobileNumber: '',
    userStatus: '',
    salesForceType: '',
    salesForceRankType: '',
    employmentType: '',
    userGrade: '',
    supervisor: '',
    supervisorName: '',
    agencyCode: '',
    dateOfBirth: '',
    jobStartDate: '',
    jobEndDate: '',
    educationDegreeCode: '',
    gender: '',
    workingExperience: '',
    previousCompany: '',
    additionalInfo: '',
    salesForceYN: 'N',
    seaoUser: 'N',
    photo: {},
    // photoForm: null,
    photoGuid: '00000000-0000-0000-0000-000000000000',
    faceRecognitionYN: 'Y'
  };
  let passwordValidatorList = [];
  let _userIdValidation = { validate: false, valid: true, message: '' };
  let _passwordValidation = { validate: false, valid: true, message: '' };
  let _validateAll = false;

  let _attachment = { file: undefined, filename: '', fileID: '' };

  let saveForm = () => {
    let _isValid = _validate();
    _attrs.submit(_userInfoForm, _isValid);
  }
  function checkPasswordComplexity(e) {
    passwordValidatorList = passwordChecker.check(e.target.value, loginModel.credentials.userID, true)["validateMessages"];
  }
  let _validate = () => {
    if (_userInfoForm.userId == '') { console.log('userId is required..'); return false; }
    if (_userInfoForm.userName == '') { console.log('userName is required..'); return false; }
    if (_userInfoForm.countryCode == '') { console.log('countryCode is required..'); return false; }
    if (_userInfoForm.userType == '') { console.log('userType is required..'); return false; }
    if (_userInfoForm.userType == "001") {
      if (_userInfoForm.knoxID == '') { console.log('knoxId is required..'); return false; }
    }
    if (_userInfoForm.email == '') { console.log('email is required..'); return false; }
    if (_userInfoForm.password == '') { console.log('password is required..'); return false; }
    if (_userInfoForm.confirmPassword == '') { console.log('confirmPassword is required..'); return false; }
    if (_userInfoForm.divisionGroup.length <= 0) { console.log('divisionGroup is required..'); return false; }
    if (_userInfoForm.language == '') { console.log('language is required..'); return false; }
    if (_userInfoForm.userStatus == '') { console.log('userStatus is required..'); return false; }
    if (_userInfoForm.salesForceType == '') { console.log('salesForceType is required..'); return false; }
    if (_userInfoForm.salesForceRankType == '') { console.log('salesForceRankType is required..'); return false; }
    if (_userInfoForm.employmentType == '') { console.log('employmentType is required..'); return false; }
    if (_userInfoForm.userGrade == '') { console.log('userGrade is required..'); return false; }
    let invalidPwCount = passwordValidatorList.filter(x => x.isValid == false);
    if (invalidPwCount.length > 0) { console.log('password complexity not matched with given password'); return false; };

    return true;
  }

  let setUserIdValidation = (_validate, _valid, _message) => {
    _userIdValidation.validate = _validate;
    _userIdValidation.valid = _valid;
    _userIdValidation.message = _message;
    this.state.userIdValidation = _userIdValidation;
  }

  let validateUserID = (val) => {
    if (val.trim() == '') {
      setUserIdValidation(true, false, this.getText("EM00000294", "UserId required."));
      return;
    }
    if (_userInfoForm.userId == val) {
      return;
    }
    _userInfoForm.userId = val;
    userModel.checkUserID(
      (res) => {
        if (res[0].transStatus == transStatus.success) {
          setUserIdValidation(true, true, '');
        } else {
          setUserIdValidation(true, false, res[0].message);
        }
      },
      (err) => {
        if (err.code == apiStatusCodes.badRequest) {
          setUserIdValidation(true, false, err.response[0].message);
        } else {
          this.handleError(err);
        }
      },
      val)
  }

  let setPasswordValidation = (_validate, _valid, _message) => {
    _passwordValidation.validate = _validate;
    _passwordValidation.valid = _valid;
    _passwordValidation.message = _message;
    this.state.passwordValidation = _passwordValidation;
  }

  let validatePassword = (passId, confirmPassId) => {
    var pVal = document.getElementById(passId).value;
    var cpVal = document.getElementById(confirmPassId).value;

    if (cpVal == '') return;

    _userInfoForm.password = pVal;
    _userInfoForm.confirmPassword = cpVal;

    if (pVal.trim() == '' && cpVal.trim() == '') {
      setPasswordValidation(true, false, this.getText("EM00000294", "UserId required."));
      return;
    }

    if (pVal != cpVal) {
      setPasswordValidation(true, false, this.getText("EM00000295", "Passwords do not match."));
      return;
    }
    setPasswordValidation(true, true, '');
  }

  let checkPassword = (password) => {
    _userInfoForm.password = password;
    var result = passwordChecker.check(password, 'clinton');
  }

  let fileChange = (e) => {
    _attachment.file = e.files[0];
    _attachment.filename = e.files[0]?.name;
    _attachment.fileID = e.files[0]?.lastModified;
    _userInfoForm.photoGuid = e.files[0]?.name;
    _userInfoForm.photo = _attachment;
    // _userInfoForm.photoForm = new FormData();
    // _userInfoForm.photoForm.append("file", e.files[0]);
  }
  let fileClear = (e) => {
    _attachment.file = undefined;
    _attachment.filename = "";
    _attachment.fileID = "";
    _userInfoForm.photo = null;
    // _userInfoForm.photoForm = null;
    _userInfoForm.photoGuid = '00000000-0000-0000-0000-000000000000';
  }


  let countryChanged = (val) => {
    let hasChange = _userInfoForm.countryCode != val;
    _userInfoForm.countryCode = val;
    _attrs.defaultCountry.code = _userInfoForm.countryCode;
    _attrs.defaultCountry.name = _userInfoForm.countryCode;
    _attrs.defaultCountry.isChanged = hasChange;
    _userInfoForm.agencyCode = '';
    _userInfoForm.employmentType = '';
    _userInfoForm.userGrade = '';
    m.redraw();
    if (hasChange) {
      _attrs.defaultCountry.countryMapLoaded = false;
      _attrs.defaultCountry.countryUdfLoaded = false;
    }
  }

  let seaoUserChange = (e) => {
    let isChecked = e.target.checked;
    _userInfoForm.seaoUser = isChecked ? 'Y' : 'N';
    _attrs.defaultCountry.seaoUser = isChecked;
  }
  let _filePreview = (fileMasterId) => {
    fileModel.getUserImageFile(
      (result) => {
        _isPreviewOpen = true;
        _base64Image = result.fileContent;
      },
      (error) => {
        this.handleError(error);
      },
      fileMasterId
    )
  }
  return {
    oninit: (vnode) => {
      this.initState(vnode.state);
      this.state.userIdValidation = _userIdValidation;
      this.state.passwordValidation = _passwordValidation;
      _attrs = vnode.attrs;
      _userInfoForm.countryCode = _attrs.defaultCountry.code;
      _userInfoForm.userStatus = '0001';
    },
    onupdate: () => {
      saveForm();
    },
    view: ({ attrs }) => {
      _attrs = attrs;
      _validateAll = _attrs.needToValidate;
      var _uv = this.state.userIdValidation;
      var _up = this.state.passwordValidation;
      if (_attrs.infoForm?.userId && !_userInfoForm.userId) _userInfoForm = _attrs.infoForm;

      return [m('.row',
        m("div", { "class": "col-md-12" },
          m("div", { "class": "d-flex bd-highlight" },
            m("div", { "class": "" },
              m("a", {
                "class": "btn btn-primary btn-search", "href": "#showGeneralInfo", "data-bs-toggle": "collapse",
                "role": "button", "aria-expanded": "true", "aria-controls": "showGeneralInfo"
              },
                m("span", { "class": "search-arrow me-2" },
                  [
                    m("i", { "class": "bi bi-chevron-down" })
                  ]
                ),
                this.getText("LT00000223", "General Information")
              )
            )
          ),

          m("div", { "class": "card_ searchbox no-leftradius collapse show", "id": "showGeneralInfo" },
            m("div", { "class": "card-body_" },
              m("div", { "class": "row g-3" },
                m("div", { "class": "" },
                  m('fieldset',
                    m('.row.mb-3',
                      m(textInputComponent, {
                        label: this.getText("LT00000049", "User ID"),
                        placeholder: this.getText("LT00000049", "User ID"),
                        value: _userInfoForm.userId,
                        onchange: (e) => { validateUserID(e.target.value); },
                        mandatory: true,
                        disabled: _attrs.isnew && _attrs.isnew !== '1',
                        isvalid: _uv.valid,
                        validate: _uv.validate,
                        errorMessage: _uv.message
                      }),
                      m(textInputComponent, {
                        label: this.getText("LT00000050", "User Name"),
                        placeholder: this.getText("LT00000050", "User Name"),
                        value: _userInfoForm.userName,
                        onchange: (e) => { _userInfoForm.userName = e.target.value; },
                        mandatory: true,
                        isvalid: _userInfoForm.userName != '',
                        errorMessage: this.getText("EM00000296", "User Name required."),
                        validate: _validateAll
                      }),
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000188", "Country"),
                        category: codeMasterType.country,
                        selectedValue: _userInfoForm.countryCode,
                        onchange: (val) => { countryChanged(val); },
                        countryCode: loginModel.credentials.country,
                        addEmpty: false,
                        mandatory: true,
                        isvalid: _userInfoForm.countryCode != '',
                        errorMessage: this.getText("EM00000297", "Default Country required."),
                        validate: _validateAll
                      }),
                    ),
                    m('.row.mb-3',
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000193", "User Type"),
                        category: codeMasterType.userType,
                        selectedValue: _userInfoForm.userType,
                        onchange: (val) => { _userInfoForm.userType = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: true,
                        mandatory: true,
                        isvalid: _userInfoForm.userType != '',
                        errorMessage: this.getText("EM00000298", "User Type required."),
                        validate: _validateAll
                      }),
                      m(textInputComponent, {
                        label: this.getText("LT00000189", "Knox ID"),
                        placeholder: this.getText("LT00000189", "Knox ID"),
                        id: 'txtKnoxId',
                        value: _userInfoForm.knoxID,
                        onchange: (e) => { _userInfoForm.knoxID = e.target.value; },
                        mandatory: _userInfoForm.userType == '0001',
                        isvalid: _userInfoForm.userType == '0001' ? _userInfoForm.knoxID != '' : true,
                        errorMessage: this.getText("EM00000299", "Know ID required."),
                        validate: _validateAll
                      }),
                      m(textInputComponent, {
                        label: this.getText("LT00000190", "Email"),
                        placeholder: this.getText("LT00000190", "Email"),
                        id: 'txtEmail',
                        value: _userInfoForm.email,
                        onchange: (e) => { _userInfoForm.email = e.target.value; },
                        mandatory: true,
                        isvalid: _userInfoForm.email != '',
                        errorMessage: this.getText("EM00000300", "Email required."),
                        validate: _validateAll
                      }),
                    ),
                  ),
                  (_attrs.isnew && _attrs.isnew == "1") && m('fieldset',
                    m('.row.mb-3',
                      m(textInputComponent, {
                        label: this.getText("LT00000280", "Password"),
                        placeholder: this.getText("LT00000280", "Password"),
                        id: 'txtPasword',
                        value: _userInfoForm.password,
                        onchange: (e) => { validatePassword('txtPasword', 'txtConfirmPassword'); },
                        oninput: (e) => { checkPassword(e.target.value); },
                        onkeyup: (e) => { checkPasswordComplexity(e) },
                        type: 'password',
                        mandatory: true,// _userInfoForm.userType != '0001',
                        isvalid: _up.valid,
                        validate: _up.validate,
                        errorMessage: _up.message
                      }),
                      m(textInputComponent, {
                        label: this.getText("LT00000245", "Confirm Password"),
                        placeholder: this.getText("LT00000245", "Confirm Password"),
                        id: 'txtConfirmPassword',
                        value: _userInfoForm.confirmPassword,
                        onchange: (e) => { validatePassword('txtPasword', 'txtConfirmPassword'); },
                        type: 'password',
                        mandatory: true,// _userInfoForm.userType != '0001',
                        isvalid: _up.valid,
                        validate: _up.validate,
                        errorMessage: _up.message
                      }),
                      passwordValidatorList.map(error =>
                        [
                          !error.isValid && m('div', { "class": "invalid-feedback fs-6 d-block" },
                            m('i.bi.bi-x-square.mr-6'),
                            m('small', this.getText(error.code, error.message))
                          ),
                          error.isValid && m('div', { "class": "valid-feedback fs-6 d-block" },
                            m('i.bi.bi-check2-square.mr-6'), m('small', this.getText(error.code, error.message))
                          )
                        ])
                    )
                  ),
                  m('fieldset',
                    m('.row.mb-3',
                      m(selectListComponent, {
                        category: codeMasterType.divisionGroup,
                        label: this.getText("LT00000246", "Division Group"),
                        handleSelect: (lst) => { _userInfoForm.divisionGroup = lst; },
                        selectedList: _userInfoForm.divisionGroup,
                        countryCode: _attrs.defaultCountry?.code,
                        mandatory: true,
                        isvalid: _userInfoForm.divisionGroup?.length > 0,
                        errorMessage: this.getText("EM00000301", "Division Group required."),
                        validate: _validateAll
                      }),
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000195", "Language"),
                        category: codeMasterType.language,
                        selectedValue: _userInfoForm.languageCode,
                        onchange: (val) => { _userInfoForm.languageCode = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: true,
                        mandatory: true,
                        isvalid: _userInfoForm.languageCode != '',
                        errorMessage: this.getText("EM00000302", "Language required."),
                        validate: _validateAll
                      }),
                      m(textInputComponent, {
                        label: this.getText("LT00000247", "Contact Number"),
                        placeholder: this.getText("LT00000247", "Contact Number"),
                        id: 'txtContactNumber',
                        value: _userInfoForm.mobileNumber,
                        onchange: (e) => { _userInfoForm.mobileNumber = e.target.value; },
                      }),
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000221", "User Status"),
                        category: codeMasterType.userStatus,
                        selectedValue: _userInfoForm.userStatus,
                        onchange: (val) => { _userInfoForm.userStatus = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: false,
                        mandatory: true,
                        isvalid: _userInfoForm.userStatus != '',
                        errorMessage: this.getText("EM00000303", "User Status required."),
                        validate: _validateAll
                      }),
                    ),
                  ),
                  m('fieldset',
                    m('.row.mb-3',
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000192", "Sales Force Type"),
                        category: codeMasterType.salesForceType,
                        selectedValue: _userInfoForm.salesForceType,
                        onchange: (val) => { _userInfoForm.salesForceType = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: true,
                        mandatory: true,
                        isvalid: _userInfoForm.salesForceType != '',
                        errorMessage: this.getText("EM00000304", "Sales Force Type required."),
                        validate: _validateAll
                      }),
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000194", "Sales Force Rank Type"),
                        category: codeMasterType.salesForceRankType,
                        selectedValue: _userInfoForm.salesForceRankType,
                        onchange: (val) => { _userInfoForm.salesForceRankType = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: true,
                        mandatory: true,
                        isvalid: _userInfoForm.salesForceRankType != '',
                        errorMessage: this.getText("EM00000305", "Sales Force Rank Type required."),
                        validate: _validateAll
                      }),
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000248", "Employment Type"),
                        category: codeMasterType.employmentType,
                        selectedValue: _userInfoForm.employmentType,
                        onchange: (val) => { _userInfoForm.employmentType = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: true,
                        mandatory: true,
                        isvalid: _userInfoForm.employmentType != '',
                        errorMessage: this.getText("EM00000306", "Employment Type required."),
                        validate: _validateAll
                      }),
                    ),
                    m('.row.mb-3',
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000249", "User Grade"),
                        category: codeMasterType.userGrade,
                        selectedValue: _userInfoForm.userGrade,
                        onchange: (val) => { _userInfoForm.userGrade = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: true,
                        mandatory: true,
                        isvalid: _userInfoForm.userGrade != '',
                        errorMessage: this.getText("EM00000307", "User Grade required."),
                        validate: _validateAll
                      }),
                      m('.col',
                        m('label.form-label', this.getText("LT00000271", "Supervisor")),
                        m(SelectUserComponent, {
                          default: {
                            userStatusCode: '0001'
                          },
                          onSelect: (u) => {
                            if (u.length > 0) {
                              _userInfoForm.supervisor = u[0].userID;
                              _userInfoForm.supervisorName = u[0].userName;
                            } else {
                              _userInfoForm.supervisor = '';
                              _userInfoForm.supervisorName = '';  
                            }
                          },
                          selectedUserList: _userInfoForm.supervisor !== '' && [{ userID: _userInfoForm.supervisor, userName: _userInfoForm.supervisorName }],
                          multiple: false
                        }),
                      ),
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000253", "Agency"),
                        category: codeMasterType.agency,
                        selectedValue: _userInfoForm.agencyCode,
                        onchange: (val) => { _userInfoForm.agencyCode = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: true,
                      }),
                    )
                  ),
                  m('fieldset',
                    m('.row.mb-3',
                      m('.col',
                        m('.col',
                          m('label.form-label', this.getText("LT00000226", "Date Of Birth")),
                          m(DatePickerComponent, {
                            class: 'form-control',
                            isRange: false,
                            maxDate: moment().add(15, 'years').format(FORMATS.dateFormat),
                            date: this.dateStringFormat(_userInfoForm.dateOfBirth), // default date range
                            onselect: (e) => {
                              _userInfoForm.dateOfBirth = moment(e.detail.date).format(FORMATS.apiDateFormat);
                            }
                          })
                        )
                      ),
                      m('.col',
                        m('.col',
                          m('label.form-label', this.getText("LT00000227", "Job Start Date")),
                          m(DatePickerComponent, {
                            class: 'form-control',
                            isRange: false,
                            maxYear: moment().add(1, 'years').format('YYYY'),
                            date: this.dateStringFormat(_userInfoForm.jobStartDate), // default date range
                            onselect: (e) => {
                              _userInfoForm.jobStartDate = moment(e.detail.date).format(FORMATS.apiDateFormat);
                            }
                          })
                        )
                      ),
                      m('.col',
                        m('.col',
                          m('label.form-label', this.getText("LT00000228", "Job End Date")),
                          m(DatePickerComponent, {
                            class: 'form-control',
                            isRange: false,
                            date: this.dateStringFormat(_userInfoForm.jobEndDate), // default date range
                            onselect: (e) => {
                              _userInfoForm.jobEndDate = moment(e.detail.date).format(FORMATS.apiDateFormat);
                            }
                          })
                        )
                      )
                    )
                  ),
                  m('fieldset',
                    m('.row.mb-3',
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000254", "Education Degree"),
                        category: codeMasterType.educationDegree,
                        selectedValue: _userInfoForm.educationDegreeCode,
                        onchange: (val) => { _userInfoForm.educationDegreeCode = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: true,
                      }),
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000255", "Gender"),
                        category: codeMasterType.gender,
                        selectedValue: _userInfoForm.gender,
                        onchange: (val) => { _userInfoForm.gender = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: true,
                      }),
                      m(codeMasterDropdownInputComponent, {
                        label: this.getText("LT00000256", "Working Experience"),
                        category: codeMasterType.workingExperience,
                        selectedValue: _userInfoForm.workingExperience,
                        onchange: (val) => { _userInfoForm.workingExperience = val; },
                        countryCode: _attrs.defaultCountry?.code,
                        addEmpty: true,
                      }),
                    ),
                    m('.row',
                      m('.col-md-4',
                        m(textInputComponent, {
                          label: this.getText("LT00000257", "Previous Company"),
                          placeholder: this.getText("LT00000257", "Previous Company"),
                          value: _userInfoForm.previousCompany,
                          onchange: (e) => { _userInfoForm.previousCompany = e.target.value; },
                        }),
                      ),
                      m('.col-md-4',
                        m(textInputComponent, {
                          label: this.getText("LT00000258", "Additional Info"),
                          placeholder: this.getText("LT00000258", "Additional Info"),
                          value: _userInfoForm.additionalInfo,
                          onchange: (e) => { _userInfoForm.additionalInfo = e.target.value; },
                        }),
                      ),
                      m('.col-md-4',

                        m(fileInputComponent, {
                          label: this.getText("LT00000259", "Photo"),
                          onchange: fileChange,
                          onClear: () => { _userInfoForm.photoGuid = ""; fileClear() },
                          fileID: _userInfoForm.photoGuid,
                          accept: '.png,.jpeg,.jpg',
                          onPreview: (id) => {
                            _filePreview(id);
                          },
                        }),
                      )
                    )
                  ),
                  m('.row.mt-4',

                    false && m('.col-md-2',
                      m(checkboxInputComponent, {
                        label: 'Sales Force User',
                        value: _userInfoForm.salesForceYN == 'Y' ? true : false,
                        onclick: (e) => { _userInfoForm.salesForceYN = e.target.checked ? 'Y' : 'N'; },
                      }),
                    ),
                    m('.col-md-2',
                      m(checkboxInputComponent, {
                        label: this.getText("LT00000260", "SEAO User"),
                        value: _userInfoForm.seaoUser == 'Y' ? true : false,
                        onclick: (e) => { seaoUserChange(e); },
                      }),
                    ),
                    (loginModel.credentials.admin) && m('.col-md-4',
                      m(checkboxInputComponent, {
                        label: this.getText("LT00000711", "Face Recognition"),
                        value: _userInfoForm.faceRecognitionYN == 'Y' ? true : false,
                        onclick: (e) => {
                          let isCheckedFR = e.target.checked;
                          _userInfoForm.faceRecognitionYN = isCheckedFR ? 'Y' : 'N';
                        },
                      }),
                    )
                  ),
                )
              )
            )
          ),// End Search Box

        ),
      ),
      m(Dialog, {
        isOpen: _isPreviewOpen,
        onClose: () => { _isPreviewOpen = false; },
        transitionDuration: 200,
        closeOnOutsideClick: false,
        title: "Image Preview",
        content: m('img[src="' + _base64Image + '"]', { "style": "width:100%;height:100%" }),
        "class": "cui-dialog-sm"
      }),
      this.getBaseViews()];
    },
  };
}
